import { useTranslation } from 'react-i18next';

const categoryItems = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20premium%20white%20leather%20sneakers%20on%20warm%20beige%20minimalist%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%20from%20left%2C%20subtle%20shadows%20on%20cream%20surface%2C%20elegant%20simple%20composition%2C%20fashion%20editorial%20style%2C%20high%20detail%20leather%20texture%20visible%2C%20no%20text%20no%20logos%2C%20serene%20neutral%20tones&width=400&height=300&seq=cat-shoes-01&orientation=landscape',
  },
  {
    key: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Oversized%20cozy%20cream%20colored%20hoodie%20laid%20flat%20on%20light%20sand%20textured%20surface%2C%20minimalist%20product%20display%2C%20soft%20warm%20natural%20lighting%2C%20cotton%20fabric%20texture%20visible%2C%20clean%20Scandinavian%20aesthetic%2C%20gentle%20folds%20and%20draping%2C%20no%20text%20no%20logos%20no%20people%2C%20serene%20neutral%20palette&width=400&height=300&seq=cat-hoodies-02&orientation=landscape',
  },
  {
    key: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Premium%20quality%20white%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20beige%20linen%20background%2C%20minimalist%20fashion%20product%20photography%2C%20soft%20diffused%20daylight%2C%20clean%20crisp%20texture%20visible%2C%20elegant%20simple%20composition%2C%20no%20text%20no%20logos%2C%20serene%20aesthetic&width=400&height=300&seq=cat-tshirts-03&orientation=landscape',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Stylish%20beige%20lightweight%20bomber%20jacket%20hung%20on%20wooden%20hanger%20against%20soft%20cream%20wall%2C%20minimalist%20product%20photography%2C%20warm%20natural%20lighting%2C%20subtle%20fabric%20texture%20details%2C%20clean%20elegant%20composition%2C%20no%20text%20no%20logos%2C%20Scandinavian%20fashion%20aesthetic&width=400&height=300&seq=cat-jackets-04&orientation=landscape',
  },
  {
    key: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Tailored%20cream%20colored%20trousers%20neatly%20folded%20on%20light%20sand%20textured%20surface%2C%20minimalist%20fashion%20product%20display%2C%20soft%20warm%20natural%20lighting%2C%20premium%20fabric%20texture%20visible%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20elegant%20neutral%20aesthetic&width=400&height=300&seq=cat-pants-05&orientation=landscape',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20beige%20baseball%20cap%20placed%20on%20warm%20cream%20surface%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20subtle%20shadow%20details%2C%20simple%20elegant%20composition%2C%20no%20text%20no%20logos%2C%20serene%20neutral%20tones%2C%20fashion%20editorial%20style&width=400&height=300&seq=cat-headwear-06&orientation=landscape',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Coordinated%20beige%20and%20cream%20casual%20outfit%20set%20neatly%20arranged%20on%20light%20sand%20textured%20background%2C%20minimalist%20fashion%20product%20display%2C%20soft%20warm%20daylight%2C%20matching%20hoodie%20and%20jogger%20set%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20serene%20aesthetic&width=400&height=300&seq=cat-sets-07&orientation=landscape',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20set%20in%20soft%20neutral%20beige%20tone%20folded%20on%20cream%20linen%20surface%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20natural%20lighting%2C%20clean%20elegant%20composition%2C%20subtle%20fabric%20texture%2C%20no%20text%20no%20logos%2C%20sophisticated%20aesthetic&width=400&height=300&seq=cat-underwear-08&orientation=landscape',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Clean%20white%20sports%20jersey%20with%20subtle%20textured%20fabric%20laid%20flat%20on%20warm%20beige%20background%2C%20minimalist%20athletic%20product%20photography%2C%20soft%20natural%20lighting%2C%20crisp%20details%20visible%2C%20elegant%20composition%2C%20no%20text%20no%20logos%2C%20serene%20sporty%20aesthetic&width=400&height=300&seq=cat-jersey-09&orientation=landscape',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Collection%20of%20minimalist%20fashion%20accessories%20including%20a%20leather%20strap%20watch%20and%20delicate%20gold%20toned%20chain%20on%20cream%20textured%20surface%2C%20soft%20warm%20natural%20lighting%2C%20elegant%20product%20photography%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20sophisticated%20neutral%20aesthetic&width=400&height=300&seq=cat-accessories-10&orientation=landscape',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20brown%20leather%20tote%20bag%20placed%20on%20warm%20sand%20colored%20surface%2C%20premium%20product%20photography%20with%20soft%20natural%20daylight%2C%20rich%20leather%20texture%20details%20visible%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20sophisticated%20Scandinavian%20aesthetic&width=400&height=300&seq=cat-bags-11&orientation=landscape',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Fine%20leather%20belt%20in%20warm%20cognac%20brown%20tone%20elegantly%20coiled%20on%20cream%20linen%20surface%2C%20minimalist%20accessory%20product%20photography%2C%20soft%20natural%20lighting%20highlighting%20leather%20grain%20texture%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20refined%20aesthetic&width=400&height=300&seq=cat-belts-12&orientation=landscape',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20frosted%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20beige%20textured%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20subtle%20reflections%20on%20glass%2C%20clean%20sophisticated%20product%20photography%2C%20no%20text%20no%20logos%2C%20serene%20luxury%20aesthetic&width=400&height=300&seq=cat-perfumes-13&orientation=landscape',
  },
  {
    key: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=Assorted%20minimalist%20lifestyle%20accessories%20including%20a%20ceramic%20mug%20and%20linen%20notebook%20on%20cream%20textured%20surface%2C%20warm%20natural%20lighting%2C%20clean%20Scandinavian%20product%20photography%2C%20elegant%20simple%20composition%2C%20no%20text%20no%20logos%2C%20serene%20neutral%20aesthetic&width=400&height=300&seq=cat-other-14&orientation=landscape',
  },
];

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('categories.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categoryItems.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.img}
                  alt={t(`categories.${cat.key}`)}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="px-3 py-2.5 text-center">
                <span className="text-xs md:text-sm font-medium text-foreground-700 leading-tight whitespace-nowrap">
                  {t(`categories.${cat.key}`)}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}